import { getExtras } from '@additional-services/store/selectors/extras.selector';
import { getOffers } from '@view-offers/store/selectors/offers.selector';
import { getSelectedOffer } from '@product-details/store/selectors/selected.selector';
import { createSelector } from '@ngrx/store';
import { ReplacementOffer, Offers } from '@dgx-pr-spa/shared/util';

export function reduceExtras(extras) {
  return extras
    ? extras.reduce(
        (accumulator, extra) =>
          extra.charge_customer ? accumulator + extra.price_gross : accumulator,
        0
      )
    : 0;
}

export const replacementCost = createSelector(
  [getSelectedOffer, getOffers, getExtras],
  (selectedItem, offers, extras) => {
    const upgradeFee = (selectedItem as ReplacementOffer)?.upgrade_fee || 0;
    const outstandingAmount =
      (offers as Offers).offer?.outstanding_dd_amount || 0;
    const extrasTotalPrice = parseFloat(reduceExtras(extras).toFixed(2));
    const total = parseFloat(
      (upgradeFee + outstandingAmount + extrasTotalPrice).toFixed(2)
    );
    return total;
  }
);
